import { ActionsColumn } from '@otp/ui';
import { DocumentNode } from 'graphql';
import { AddToFavorites } from 'src/components/most/common/add-to-favorites';
import { ReplayCommand } from 'src/components/most/common/replay-command';
import {
  MostRequestHistory,
  MostRunCommandType,
} from 'src/graphql/generated/graphql';

type ActionsFieldProps = {
  record: MostRequestHistory;
  refetchQueries?: DocumentNode[];
};

export const ActionsField = ({
  record,
  refetchQueries = [],
}: ActionsFieldProps) => {
  const isQuery = !!record.queryId;

  const actions = [
    {
      icon: (
        <AddToFavorites
          defaultValue={{
            jobConfig: {
              command: {
                commandId: isQuery
                  ? (record.queryId as string)
                  : (record.triageId as string),
                name: isQuery
                  ? (record?.queryName as string)
                  : (record?.triageName as string),
                type: isQuery
                  ? MostRunCommandType.Query
                  : MostRunCommandType.Triage,
              },
              devices: [record.device],
              storeIds: [record.store?.id as string],
            },
          }}
          refetchQueries={[...refetchQueries]}
          checkIfIsFavourited={true}
        />
      ),
    },
    {
      icon: (
        <ReplayCommand
          command={{
            device: record.device,
            queryId: record.queryId,
            nationalStoreNumber: record.store?.nationalStoreNumber as string,
          }}
          refetchQueries={refetchQueries}
        />
      ),
    },
  ];

  return <ActionsColumn icons={actions} />;
};
